module.exports = __webpack_public_path__ + "static/media/pteronemobius_heydenii_002_APA.c6a846bf.mp3";